import { SessionReport } from '../model/session-report';

export const defaultPrice = 30;
export const higherPrice = 36;
export const accountabilityPayDeduction = 7.25;
export const lowerAccountabilityPayDeduction = 6.25;
export const hybridSesssionPrice = 60;
export const voucherSessionPrice = 15;

export function totalBillableSessions(sessionReport: SessionReport, currentCoachHigherPayGrade: boolean): number {
    console.log(currentCoachHigherPayGrade);
    let totalSum = 0;
    const baseSessions = getBaseSessionsCount(sessionReport);

    totalSum += baseSessions * (sessionReport.higherPayGrade ? higherPrice : defaultPrice);
    totalSum += forOtherCoachesSum(sessionReport, currentCoachHigherPayGrade);
    totalSum += byOtherCoachesHigherPayGradeSum(sessionReport);
    totalSum += byOtherCoachesLowerPayGradeSum(sessionReport);
    totalSum += sessionReport.hybridSessions > 0 ? hybridSesssionPrice : 0;
    totalSum += sessionReport.voucherSessions * voucherSessionPrice;

    return totalSum;
}

export function getBaseSessionsCount(sessionReport: SessionReport) {
    return (
        sessionReport.completedSessionCount + // changed this from - to +
        sessionReport.lateCancelSessionCount - // added this 14.5.2025 since calculator was not calculating late cancel sessions
        sessionReport.sessionsDoneForOtherCoaches -
        sessionReport.sessionsDoneByOtherCoaches -
        (sessionReport.hybridSessions > 0 ? 1 : 0) -
        sessionReport.voucherSessions -
        sessionReport.cacSessions
    );
}

export function forOtherCoachesSum(sessionReport: SessionReport, currentCoachHigherPayGrade: boolean): number {
    const unitPrice = sessionReport.higherPayGrade ? higherPrice : defaultPrice;
    return (
        sessionReport.sessionsDoneForOtherCoaches *
        (unitPrice -
            (currentCoachHigherPayGrade === true ? accountabilityPayDeduction : lowerAccountabilityPayDeduction))
    );
}

export function byOtherCoachesHigherPayGradeSum(sessionReport: SessionReport): number {
    return sessionReport.sessionsDoneByOtherCoachesSplit.sessionsWithHigherPayGrade * accountabilityPayDeduction;
}
export function byOtherCoachesLowerPayGradeSum(sessionReport: SessionReport): number {
    return sessionReport.sessionsDoneByOtherCoachesSplit.sessionsWithLowerPayGrade * lowerAccountabilityPayDeduction;
}
